module.exports = __webpack_public_path__ + "static/img/banner.0f9bebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/img/banner.png
// module id = mQXh
// module chunks = 26